<app-tela-tabela-precos-v2
  *ngIf="empresa && temModuloTabelaPrecos"
  [empresa]="empresa"
  [modoPagina]="true"
  [produtosV2Ativo]="true"
  (closeRequested)="volteParaProdutos()">
</app-tela-tabela-precos-v2>

<div class="alert alert-warning" *ngIf="empresa && !temModuloTabelaPrecos">
  Módulo tabela de preços não está ativo para esta empresa.
</div>
